import { schema } from "normalizr"

export const participantSchema = new schema.Entity("participants")
